import type { detect } from 'detect-browser';

export const IE11 = '11';

// Whatever `detect()` managed to identify. Only `BrowserInfo` carries a
// `version`, so the name is checked first to narrow to it.
type DetectedBrowser = NonNullable<ReturnType<typeof detect>>;

export const isBelowIE11 = (browser: DetectedBrowser) => {
  if (browser.name !== 'ie') {
    return false;
  }

  const [major] = (browser.version ?? '').split('.').map(Number);

  return major < Number(IE11);
};
